import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { InsuranceService } from '../../../../services/insurance.service';

@Component({
  selector: 'app-insurance-quote-creation',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InsuranceQuoteCreationComponent implements OnInit {
  public showClaim: boolean = true;
  public products: any = [];
  public searchResult: any = [];
  public editLine: any = {};
  public productSearch: any = {};
  public editing: boolean = false;
  public invoice: any = {};

  public showMessage: boolean = false;
  public showQuote: boolean = false;

  public columns: any = [];
  public quotes: any = [];

  public message: string = '';
  public sending: boolean = false;
  messages: any[] = [];

  public VATInclusive = true;
  public allowDiscount = false;
  activeBikeID: number = 0;
  partnerID: string = '';

  constructor(
    public insuranceService: InsuranceService,
    public helpersService: HelpersService,
  ) {
    this.products = this.helpersService.getProductData();
  }

  ngOnInit() {
    this.invoice.LineItems = [];
    this.invoice.CurrencySymbol = 'R';
    this.invoice.Total_Tax = 0;
    this.invoice.Total_LineItems = 0;
    this.invoice.Total_Price = 0;
    this.invoice.PartnerID = this.helpersService.getPartnerId();

    this.columns = [
      { header: 'Claim', field: 'ClaimNumber', type: 'string' },
      { header: 'Insurer', field: 'Insurer', type: 'string' },
      { header: 'Customer', field: 'InsuredName', type: 'string' },
      { header: 'Bike', field: 'Bike', type: 'string' },
      { header: '', field: 'BikeID', type: 'action' },
    ];

    this.quotes = [];

    var pid = this.helpersService.getPartnerId();

    this.insuranceService
      .getClaimQuotesForPartners(pid)
      .subscribe((response) => {
        if (response != '') {
          var obj = JSON.parse(response);
          for (var i = 0; i < obj.PartnerQuotes.length; i++) {
            this.quotes.push(obj.PartnerQuotes[i]);
            //{
            //  ClaimNumber: obj.PartnerQuotes[i].ClaimID,
            //  Insurer: obj.PartnerQuotes[i].Insurer,
            //  InsuredName: obj.PartnerQuotes[i].InsuredName,
            //  BikeID: obj.PartnerQuotes[i].BikeID,
            //  Bike: obj.PartnerQuotes[i].Bike
            //});
          }
        }
      });
  }

  RefreshQuotes() {
    this.quotes = [];

    var pid = this.helpersService.getPartnerId();

    this.insuranceService
      .getClaimQuotesForPartners(pid)
      .subscribe((response) => {
        if (response != '') {
          var obj = JSON.parse(response);
          for (var i = 0; i < obj.PartnerQuotes.length; i++) {
            this.quotes.push(obj.PartnerQuotes[i]);
          }
        }
      });
  }

  sendMessage() {
    this.partnerID = this.helpersService.getPartnerId();

    this.sending = true;
    this.insuranceService
      .sendMessageToRaw({
        message: this.message,
        number: '',
        BikeID: this.activeBikeID,
        PartnerID: this.partnerID,
      })
      .subscribe((response) => {
        this.sending = false;
        this.messages = [];
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Messages.length; i++) {
          this.messages.push(obj.Messages[i]);
        }
      });
    this.message = '';
  }

  searchProducts(event) {
    //TODO does this pass all SKU's for all parners???
    //Seems to search too many fields and results not consistent with what I searched.
    /*this.productsService.searchProduct(event.query).subscribe(results=>{
              this.products = results.map(result=>result.Description);
            });*/
    //Try search the SKU type fields 1st
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        //product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (!!product.SystemSKU &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
            -1) ||
        (!!product.ManufacturerSKU &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1) ||
        (!!product.UPC &&
          product.UPC.toLowerCase().indexOf(event.query.toLowerCase()) > -1)
      );
    });

    if (results.length === 0) {
      //Use a different search to filter the Name field, this now can search the field with words in any order.
      results = this.filterList(event.query, this.products);
    }

    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      product.Discount = 0;
      product.DiscountID = 0;
      product.OriginalUnitPrice = JSON.parse(JSON.stringify(product)).UnitPrice;
      delete product.PartnerID;
      return product;
    });
    if (results.length > 0) {
      this.searchResult = results;
    } else {
      if (
        results.length === 0 &&
        event.query.length > 4 &&
        event.query.length > this.editLine.length - 1
      ) {
        //remove last character from the search and try again - Seems certain UPC products barcodes have an extra digit
        event.originalQuery = event.query;
        event.query = event.query.substr(0, event.query.length - 1);
        this.searchProducts(event);
      } else {
        //If the search above returns no records, search the DB
        if (
          event.originalQuery ||
          event.query.length === this.editLine.length - 1
        ) {
          event.query = event.originalQuery ? event.originalQuery : event.query;
          if (event.originalQuery) {
            delete event.originalQuery;
          }
          //this.searchExternal(event);
        } else {
          this.searchResult = [];
        }
      }
    }
  }

  filterList(q, list) {
    function escapeRegExp(s) {
      return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    const words = q
      .split(/\s+/g)
      .map((s) => s.trim().toLowerCase())
      .filter((s) => !!s);

    console.log(words);
    const hasTrailingSpace = q.endsWith(' ');
    const searchRegex = new RegExp(
      words
        .map((word, i) => {
          if (i + 1 === words.length && !hasTrailingSpace) {
            // The last word - ok with the word being "startswith"-like
            return `(?=.*\\b${escapeRegExp(word)})`;
          } else {
            // Not the last word - expect the whole word exactly
            //return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            //Chained it to a partial word search as per the issue with Costa Mesa
            return `(?=.*\\b${escapeRegExp(word)})`;
          }
        })
        .join('') + '.+',
      'gi',
    );
    var resultList = list.filter((item) => {
      return searchRegex.test(item.Name);
    });

    resultList.forEach((res) => {
      var nameArray = res.Name.split(' ');
      var count = 0;
      nameArray.forEach((name) => {
        if (words.includes(name.toLowerCase())) {
          count += 1;
        }
      });
      res.wordMatch = count;
    });

    resultList = resultList.sort((a, b) => {
      if (a.wordMatch > b.wordMatch) {
        return -1;
      } else if (a.wordMatch < b.wordMatch) {
        return 1;
      } else {
        return 0;
      }
    });

    return resultList;
  }

  addLineItemAuto(event) {
    let product = event;
    product.Quantity = 1;
    product.Discount = 0;
    product.DiscountID = 0;
    product.OriginalUnitPrice = product.UnitPrice;
    product.edit = true;
    delete product.PartnerID;

    this.editing = true;
    this.editLine = product;
    this.invoice.LineItems.push(product);
    //this.sent = false;
    //setTimeout(() => this.quantityComponent.nativeElement.focus(), 500);
    this.updateLine(this.invoice.LineItems.length - 1);
    this.productSearch = {};
  }

  updateLine(index) {
    this.editing = false;
    this.invoice.LineItems[index] = this.editLine;
    this.invoice.LineItems[index].Price =
      this.invoice.LineItems[index].Quantity *
      this.invoice.LineItems[index].UnitPrice;
    delete this.invoice.LineItems[index].edit;
    this.saveQuote();
  }

  editLineItem(index) {
    this.editing = true;
    this.invoice.LineItems[index].edit = true;
    this.editLine = this.invoice.LineItems[index];
    this.updateTotals();
  }

  deleteLineItem(index) {
    this.invoice.LineItems.splice(index, 1);
    this.updateTotals();
    this.saveQuote();
  }

  updateTotals() {
    this.invoice.Total_Tax = 0;
    this.invoice.Total_LineItems = 0;
    this.invoice.Total_Price = 0;

    if (
      this.invoice &&
      this.invoice.LineItems &&
      this.invoice.LineItems.length > 0
    ) {
      for (var i = 0; i < this.invoice.LineItems.length; i++) {
        this.invoice.Total_Tax +=
          (this.invoice.LineItems[i].UnitPrice_IncludingTax -
            this.invoice.LineItems[i].UnitPrice) *
          this.invoice.LineItems[i].Quantity;
        this.invoice.Total_LineItems +=
          this.invoice.LineItems[i].UnitPrice *
          this.invoice.LineItems[i].Quantity;
        this.invoice.Total_Price +=
          this.invoice.LineItems[i].UnitPrice_IncludingTax *
          this.invoice.LineItems[i].Quantity;
      }
    }
  }

  saveQuote() {
    this.updateTotals();
    this.invoice.BikeID = this.activeBikeID;
    var pID = this.helpersService.getPartnerId();
    this.invoice.PartnerID = pID;
    this.insuranceService
      .savePartnerQuote(this.invoice)
      .subscribe((response) => {
        this.invoice.LineItems = [];
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.LineItems.length; i++) {
          this.invoice.LineItems.push(obj.LineItems[i]);
        }
        console.log(this.invoice);
      });
  }

  showQuotes(BikeID) {
    this.updateTotals();
    //this.showQuote = true;
    this.activeBikeID = BikeID;
    var pID = this.helpersService.getPartnerId();
    this.insuranceService
      .getClaimQuotesFromPartners(pID, BikeID)
      .subscribe((response) => {
        this.invoice.LineItems = [];
        if (response !== undefined && response !== '') {
          var obj = JSON.parse(response);
          for (var i = 0; i < obj.LineItems.length; i++) {
            this.invoice.LineItems.push(obj.LineItems[i]);
          }
          this.updateTotals();
        }
      });
  }

  showMessages(BikeID) {
    this.invoice.LineItems = [];
    this.updateTotals();
    this.showQuotes(BikeID);
    this.activeBikeID = BikeID;
    this.messages = [];
    this.message = '';
    this.showMessage = true;
    var pID = this.helpersService.getPartnerId();
    this.insuranceService
      .getQuoteMessagesPartner(pID, BikeID)
      .subscribe((response) => {
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Messages.length; i++) {
          this.messages.push(obj.Messages[i]);
        }
      });
  }
}
